<template>
  <div class="box">
    <el-collapse v-model="activeNames">
      <el-collapse-item title="内容" name="1">
        <el-card shadow="hover" v-for="(item, index) in data.carouselImage" :key="index">
          <i class="el-icon-close" @click="handleDel(index)"></i>
          <div class="cardList">
            <div style="margin-right: 8px">
              <div class="preImg" @click="handImgUpd(index)">
                <img :src="item.src ? item.src : imgUrl" />
              </div>
              <p class="tip">最佳尺寸：500x400px</p>
            </div>
            <div class="dropdownBox">
              <input id="name" v-model="item.title" />
              <el-dropdown @command="handleLinkItem" placement="bottom-start">
                <span class="el-dropdown-link">
                  {{ item.link }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(link, idx) in data.linkList" :key="idx"
                  :command="`${link.title}#${link.page}?${index}`">{{
                      link.title
                    }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-card>

        <div>
          <el-button type="primary" style="width: 100%;" size="mini" @click="handleAddBtnClick">添加轮播</el-button>
        </div>
      </el-collapse-item>
      <el-collapse-item title="样式" name="2">
        <comSetting :infoItme="data.infoItme" />
      </el-collapse-item>
    </el-collapse>

    <imgPre v-if="uploadShow" :dialogVisible="uploadShow" @checkImg="handleImg" @onClose="uploadShow = false" />
  </div>
</template>

<script>
import imgPre from '../../components/uploadImg/imgPre'
import infoImg from '../../assets/image-upload.jpg'
import comSetting from '../comSetting'

export default {
  name: 'carouselSetting',
  components: { imgPre, comSetting },
  props: {
    data: Object
  },
  data () {
    return {
      activeNames: ['1'],
      uploadShow: false,
      imgUrl: infoImg,
      idx: 0
    }
  },
  mounted () {
    console.log('data', this.data)
  },
  methods: {
    handleAddBtnClick: function () {
      console.log('添加轮播图', this.data.carouselImage)
      this.data.carouselImage.push({
        src: infoImg,
        title: '这是标题',
        link: '导航'
      })
    },
    handleImg: function (data) {
      console.log('选择得图片', data)
      this.data.carouselImage[this.idx].src = data.url
      this.uploadShow = false
    },
    handleAvatarSuccess: function () {
      console.log()
    },
    handleDel: function (index) {
      this.data.carouselImage.splice(index, 1)
    },
    handImgUpd: function (index) {
      this.uploadShow = true
      this.idx = index
    },
    handleLinkItem (command) {
      const idx = command.indexOf('?')
      const idx1 = command.indexOf('#')
      var before = command.substring(0, idx)
      var after = command.substring(idx + 1)
      const pagetit = before.substring(0, idx1)
      const page = before.substring(idx1 + 1)
      console.log('点击选择的链接', command, page)
      this.data.carouselImage[Number(after)].link = pagetit
      this.data.carouselImage[Number(after)].page = page
    }
  }
}
</script>
<style scoped>
.box {
  padding: 35px;
}

.el-card {
  margin-bottom: 15px;
  background-color: #f9fafc;
  position: relative;
}

.el-card .cardList {
  display: flex;
  justify-content: space-around;
}

.dropdownBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cardList .preImg {
  width: 100px;
  height: 100px;
  position: relative;
  border-radius: 12px;
  cursor: pointer;
  line-height: 100px;
  text-align: center;
}

.cardList .preImg img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
}

.cardList .preImg:hover::after {
  content: "点击上传";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  border-radius: 12px;
}

.el-icon-close {
  position: absolute;
  top: 4px;
  right: 8px;
  font-size: 18px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/carousel/carouselSetting.vue